export const normalizeMobilePhone = value => `+7 ${value}`;
